"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PaymentCard = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _react = require("react");
var _PaymentProviderItem = _interopRequireDefault(require("./PaymentProviderItem"));
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Payment card displayed for example in OOB order detail.
 * @param props PaymentProps
 * @returns JSX.Element
 */

const PaymentCard = props => {
  const {
    className,
    sectionHeader,
    sectionHeadingComponent = 'div',
    sectionDecription,
    paymentProviders,
    testId,
    activeProviderId,
    setActiveProviderId
  } = props;
  const activatePaymentProvider = (0, _react.useCallback)((isBlocked, paymentProviderId) => {
    const isActive = paymentProviderId === activeProviderId;
    if (!isActive && !isBlocked) {
      setActiveProviderId(paymentProviderId);
    }
  }, [activeProviderId, setActiveProviderId]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    className: className,
    "data-test-id": testId,
    "aria-labelledby": "payment-card-header",
    role: "radiogroup",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
      variant: "h5",
      component: sectionHeadingComponent,
      id: "payment-card-header",
      children: sectionHeader
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Description, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Lock, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
        children: sectionDecription
      })]
    }), paymentProviders.map(provider => /*#__PURE__*/(0, _jsxRuntime.jsx)(_PaymentProviderItem.default, {
      provider: provider,
      isActive: provider.paymentProviderId === activeProviderId,
      activatePaymentProvider: activatePaymentProvider
    }, provider.paymentProviderId))]
  });
};
exports.PaymentCard = PaymentCard;
var _default = exports.default = PaymentCard;
